import React from "react";

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  /** Primary description text below the title. */
  description?: string;
  /** @deprecated Use `description` instead. Kept for backward compatibility. */
  subtitle?: string;
  /** Optional action element (button, link, etc.) rendered below the text. */
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  subtitle,
  action,
}) => {
  const body = description ?? subtitle;

  return (
    <div className="rounded-2xl border border-dashed border-ds-border bg-white/50 px-6 py-12 text-center">
      {icon ? (
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-ds-mist/30">
          {icon}
        </div>
      ) : null}
      <div className="text-[15px] font-semibold text-ds-ink">{title}</div>
      {body ? (
        <div className="mt-1.5 text-[13px] leading-relaxed text-ds-ink-3">{body}</div>
      ) : null}
      {action ? (
        <div className="mt-6 flex items-center justify-center">{action}</div>
      ) : null}
    </div>
  );
};
